module.exports = __webpack_public_path__ + "img/fbpdeclaration.68deeeef.svg";